import { Timeline, Typography } from 'antd';
import React from 'react';
import { CheckCircleFilled, ExclamationCircleFilled } from '@ant-design/icons';

const {Text}=Typography;

function TimelineSkeleton() {
  return (
    <div className='application-status-summary-container'>
        <div className='skeleton-timeline'>
            <Timeline style={{margin:'6px 8px 0 8px'}}>
                <Timeline.Item
                key={1}
                >
                    <div className="item-container">
                        <div style={{height: '12px', width:'60%', borderRadius:'0px'}} className="skeleton skeleton-status-header"></div>
                    </div>
                </Timeline.Item>
                <Timeline.Item
                key={2}
                >
                    <div className="item-container">
                        <div style={{height: '12px', width:'80%', borderRadius:'0px'}} className="skeleton skeleton-status-header"></div>
                    </div>
                </Timeline.Item>
            </Timeline>
        </div>
    </div>
  )
}

export default TimelineSkeleton
